const tmBook = {
  101131: 51558,
  101132: 51559,
  101133: 51560,
  101134: 51561,
  101135: 51562,
  101136: 51563,
  101137: 51564,
  101138: 51565,
  101139: 51566,
  101140: 51567,
  101141: 51568,
  101142: 51569,
  101143: 51570,
  101144: 51571,
  101145: 51572,
  101146: 51573,
  101147: 51574,
  101148: 51575,
  101149: 51576,
  101150: 51577,
  101151: 51578,
  101152: 51579,
  101153: 51580,
  101154: 51581,
  101155: 51582,
  101156: 51583,
  101157: 51584,
  101158: 51585,
  101159: 51586,
  101160: 51587,
  101161: 51588,
  101162: 51557,
  101163: 51556,
  101164: 51590,
  101165: 51591,
  101166: 51592,
  101167: 51593,
  101168: 51594,
  101169: 51595,
  101170: 51596,
  101171: 51597,
  101172: 51598,
  101173: 51599,
  101174: 51600,
  101175: 51601,
  101176: 51602,
  101177: 51603,
  101178: 51604,
  101179: 51605,
  101180: 51606,
  101181: 51607,
  101182: 51608,
  101183: 51609,
  101184: 51610,
  101185: 51611,
  101209: 51612,
  101210: 51613,
  101211: 51614,
  101212: 51615,
  101213: 51616,
  101214: 51617,
  101215: 51618,
  101346: 51619,
  101347: 51620,
  101348: 51589,
  101982: 51621,
  101983: 51622,
  101984: 51623,
  101985: 51624,
  101986: 51625,
  101987: 51626,
  101988: 51627,
  101989: 51628,
  101990: 51629,
  101991: 51630,
  101992: 51631,
  101993: 51632,
  101994: 51633,
  101995: 51634,
  101996: 51635,
  101997: 51636,
  101998: 51637,
  101999: 51638,
  102000: 51639,
  102001: 51640,
  102002: 51641,
  102003: 51642,
  102004: 51643,
}

const zpBook = {
  101598: 51656,
  101599: 51657,
  101600: 51658,
  101601: 51659,
  101602: 51660,
  101603: 51661,
  101604: 51662,
  101605: 51663,
  101606: 51664,
  101607: 51665,
  101608: 51666,
  101609: 51667,
  101610: 51668,
  101611: 51669,
  101612: 51670,
  101613: 51671,
  101614: 51672,
  101615: 51673,
  101616: 51674,
  101617: 51675,
  101618: 51676,
  101619: 51677,
  101620: 51678,
  101621: 51679,
  101622: 51680,
  101623: 51681,
  101624: 51682,
  101625: 51683,
  101626: 51684,
  101627: 51685,
  101628: 51686,
  101629: 51687,
  101630: 51688,
  101631: 51689,
  101632: 51690,
  101633: 51691,
  101634: 51692,
  101635: 51693,
  101636: 51694,
  101637: 51695,
  101638: 51696,
  101639: 51697,
  101640: 51698,
  101641: 51699,
  101642: 51700,
  101643: 51701,
  101644: 51702,
  101645: 51703,
  101646: 51704,
  101647: 51705,
  101648: 51706,
  101649: 51707,
  101650: 51708,
  101651: 51709,
  101652: 51710,
  101653: 51711,
  101654: 51712,
  101655: 51713,
  101656: 51714,
  101657: 51715,
  101658: 51716,
  101659: 51717,
  101660: 51718,
  101661: 51719,
  101662: 51720,
  101663: 51721,
  101664: 51722,
  101665: 51723,
  101666: 51724,
  101667: 51725,
  101668: 51726,
  101669: 51727,
  101670: 51728,
  101671: 51729,
  101672: 51730,
  101673: 51731,
  101674: 51732,
  101675: 51733,
  101676: 51734,
  101677: 51735,
  101678: 51736,
  101679: 51737,
  101680: 51738,
  101681: 51739,
  101682: 51740,
  101683: 51741,
  101684: 51742,
  101685: 51743,
  101686: 51744,
  101687: 51745,
  101688: 51746,
  101689: 51747,
  101690: 51748,
  101691: 51749,
  101692: 51750,
  101693: 51751,
  101694: 51752,
  101695: 51753,
  101696: 51754,
  101697: 51755,
  101698: 51756,
  101699: 51757,
  101700: 51758,
  101701: 51759,
  101702: 51760,
  101703: 51761,
  101704: 51762,
  101705: 51763,
  101706: 51764,
  101707: 51765,
  101708: 51766,
  101709: 51767,
  101710: 51768,
  101711: 51769,
  101712: 51770,
  101713: 51771,
  101714: 51772,
  101715: 51773,
  101716: 51774,
  101717: 51775,
  101718: 51776,
  101719: 51777,
  101720: 51778,
  101721: 51779,
  101722: 51780,
  101723: 51781,
  101724: 51782,
  101725: 51783,
  101726: 51784,
  101727: 51785,
  101728: 51786,
  101729: 51787,
  101730: 51788,
  101731: 51789,
  101732: 51790,
  101733: 51791,
  101734: 51792,
  101735: 51793,
  101736: 51794,
  101737: 51795,
  101738: 51796,
  101739: 51797,
  101740: 51798,
  101741: 51799,
  101742: 51800,
  101743: 51801,
  101744: 51802,
  101745: 51803,
  101746: 51804,
  101747: 51805,
  101748: 51806,
  101749: 51807,
  101750: 51808,
  101751: 51809,
  101752: 51810,
  101753: 51811,
  101754: 51812,
  101755: 51813,
  101756: 51814,
  101757: 51815,
  101758: 51816,
  101759: 51817,
  102006: 51653,
  102007: 51655,
  111881: 51654,
}

const phoneticMap = {
  101858: 51819,
  101859: 51820,
  101860: 51821,
  101861: 51822,
  101862: 51823,
  101863: 51824,
  101864: 51825,
  101865: 51826,
  101866: 51827,
  101867: 51828,
  101868: 51829,
  101869: 51830,
  101870: 51831,
  101871: 51832,
  101872: 51833,
  101873: 51834,
  101874: 51835,
  101875: 51836,
  101876: 51837,
  101877: 51838,
  101878: 51839,
  101879: 51840,
  101880: 51841,
  101881: 51842,
  101882: 51843,
  101883: 51844,
  101884: 51845,
  101885: 51846,
  101886: 51847,
  101887: 51848,
  101888: 51849,
  101889: 51850,
  101890: 51851,
  101891: 51852,
  101892: 51853,
  101893: 51854,
  101894: 51855,
  101895: 51856,
  101896: 51857,
  101897: 51858,
  101898: 51859,
  101899: 51860,
  101900: 51861,
  101901: 51862,
  101902: 51863,
  101903: 51864,
  101904: 51865,
  101905: 51866,
  101906: 51867,
}

const tikuMap = {
  111721: 51869,
  111722: 51870,
  111723: 51871,
  111724: 51872,
  111725: 51873,
  111726: 51874,
  111727: 51875,
  111728: 51876,
  111729: 51877,
  111730: 51878,
  111731: 51879,
  111732: 51880,
  111733: 51881,
  111734: 51882,
  111735: 51883,
  111736: 51884,
  111737: 51885,
  111738: 51886,
  111739: 51887,
  111740: 51888,
  111741: 51889,
  111742: 51890,
  111743: 51891,
  111744: 51892,
  111745: 51893,
  111746: 51894,
  111747: 51895,
  111748: 51896,
  111749: 51897,
  111750: 51898,
  111751: 51899,
  111752: 51900,
  111753: 51901,
  111754: 51902,
  111755: 51903,
  111756: 51904,
  111757: 51905,
  111758: 51906,
  111759: 51907,
  111760: 51908,
  111761: 51909,
  111762: 51910,
  111763: 51911,
  111764: 51912,
  111765: 51913,
  111766: 51914,
  111767: 51915,
  111768: 51916,
  111769: 51917,
  111770: 51918,
  111771: 51919,
  111772: 51920,
  111773: 51921,
  111774: 51922,
  111775: 51923,
  111776: 51924,
  111777: 51925,
  111778: 51926,
  111779: 51927,
  111780: 51928,
  111781: 51929,
  111782: 51930,
  111783: 51931,
  111784: 51932,
  111785: 51933,
  111786: 51934,
  111787: 51935,
  111788: 51936,
  111789: 51937,
  111790: 51938,
  111791: 51939,
  111792: 51940,
  111793: 51941,
  111794: 51942,
  111795: 51943,
  111796: 51944,
  111797: 51945,
  111798: 51946,
  111799: 51947,
  111800: 51948,
  111801: 51949,
  111802: 51950,
  111803: 51951,
  111804: 51952,
  111805: 51953,
  111806: 51954,
  111807: 51955,
  111808: 51956,
  111809: 51957,
  111810: 51958,
  111811: 51959,
  111812: 51960,
  111813: 51961,
  111814: 51962,
  111815: 51963,
  111816: 51964,
  111817: 51965,
  111818: 51966,
  111819: 51967,
  111820: 51968,
  111821: 51969,
  111822: 51970,
  111823: 51971,
  111824: 51972,
}

//单元转到使用jq_knowledge_english表的category，老的单元需要做下映射
export const unitMap = { ...tmBook, ...zpBook, ...phoneticMap, ...tikuMap }
